module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "lazy": "",
      "width": "600px",
      "persistent": "",
      "fullscreen": _vm.screenWidth < 600,
      "transition": "scale-transition"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-tabs', {
    attrs: {
      "light": "",
      "fixed": "",
      "centered": ""
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('v-tabs-bar', {
    staticClass: "header"
  }, [_c('v-tabs-slider', {
    staticClass: "yellow"
  }), _vm._v(" "), _vm._l((_vm.items), function(i) {
    return _c('v-tabs-item', {
      key: i,
      staticStyle: {
        "border": "none"
      },
      attrs: {
        "href": '#' + i,
        "router": ""
      }
    }, [_c('b', [_vm._v(_vm._s(i))])])
  }), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('v-icon', [_vm._v("cancel")])], 1)], 2), _vm._v(" "), _c('v-tabs-content', {
    staticStyle: {
      "height": "100%",
      "border": "none"
    },
    attrs: {
      "id": "SIGN-UP"
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "column": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-card-title', {
    staticClass: "bold title pb-1 mt-0 pt-1",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("CREATE AN ACCOUNT")]), _vm._v(" "), _c('b', {
    staticClass: "caption pt-0 pb-2"
  }, [_vm._v("continue with")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-btn', {
    staticClass: "red accent-4 white--text mr-1",
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.signUpWithGoogle.apply(null, arguments)
      }
    }
  }, [_vm._v("Sign up with Gmail")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-btn', {
    staticClass: "green accent4 white--text ml-1",
    attrs: {
      "block": ""
    }
  }, [_vm._v("Sign up with LinkedIn")])], 1)], 1), _vm._v(" "), _c('b', {
    staticClass: "caption mt-2 pb-0"
  }, [_vm._v("or")]), _vm._v(" "), _c('form', {
    staticClass: "py-0 my-0 mt-0",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSignUp.apply(null, arguments)
      }
    }
  }, [_c('v-container', {
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    ref: "confirmation",
    staticClass: "pr-2",
    staticStyle: {
      "padding-bottom": "0px",
      "margin": "0px"
    },
    attrs: {
      "label": "Email Address",
      "type": "email",
      "required": "",
      "error": false,
      "hide-details": ""
    },
    model: {
      value: (_vm.signUp.email),
      callback: function($$v) {
        _vm.$set(_vm.signUp, "email", $$v)
      },
      expression: "signUp.email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    ref: "confirmation",
    staticClass: "pr-2",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "label": "Password",
      "type": "password",
      "hint": "At least 6 characters",
      "required": "",
      "counter": "6"
    },
    model: {
      value: (_vm.signUp.password),
      callback: function($$v) {
        _vm.$set(_vm.signUp, "password", $$v)
      },
      expression: "signUp.password"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pr-2",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "label": "First Name",
      "required": ""
    },
    model: {
      value: (_vm.signUp.firstname),
      callback: function($$v) {
        _vm.$set(_vm.signUp, "firstname", $$v)
      },
      expression: "signUp.firstname"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "label": "Last Name",
      "required": ""
    },
    model: {
      value: (_vm.signUp.lastname),
      callback: function($$v) {
        _vm.$set(_vm.signUp, "lastname", $$v)
      },
      expression: "signUp.lastname"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pr-2",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "label": "Job Title",
      "required": "",
      "error": false
    },
    model: {
      value: (_vm.signUp.jobtitle),
      callback: function($$v) {
        _vm.$set(_vm.signUp, "jobtitle", $$v)
      },
      expression: "signUp.jobtitle"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pr-2",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "label": "Department",
      "required": ""
    },
    model: {
      value: (_vm.signUp.department),
      callback: function($$v) {
        _vm.$set(_vm.signUp, "department", $$v)
      },
      expression: "signUp.department"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [(_vm.notavailable) ? _c('v-select', {
    staticClass: "pr-2 mt-0",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "label": "Company Name",
      "cache-items": "",
      "loading": _vm.companyLoading,
      "items": _vm.companydirectory,
      "search-input": _vm.companySearch,
      "autocomplete": "",
      "required": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.companySearch = $event
      },
      "update:search-input": function($event) {
        _vm.companySearch = $event
      }
    },
    model: {
      value: (_vm.signUp.companylegalname),
      callback: function($$v) {
        _vm.$set(_vm.signUp, "companylegalname", $$v)
      },
      expression: "signUp.companylegalname"
    }
  }) : _c('v-text-field', {
    staticClass: "pr-2 mt-0",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "label": "Company Name",
      "required": ""
    },
    model: {
      value: (_vm.signUp.companylegalname),
      callback: function($$v) {
        _vm.$set(_vm.signUp, "companylegalname", $$v)
      },
      expression: "signUp.companylegalname"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pr-2",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "label": "Company Website",
      "required": ""
    },
    model: {
      value: (_vm.signUp.businesswebsite),
      callback: function($$v) {
        _vm.$set(_vm.signUp, "businesswebsite", $$v)
      },
      expression: "signUp.businesswebsite"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('input', {
    staticClass: "mr-2",
    attrs: {
      "id": "terms",
      "type": "checkbox",
      "required": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "terms"
    }
  }, [_vm._v("Agree to the Terms & Conditions")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "terms"
    }
  }, [_vm._v("Privacy Policy")])])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2 mb-0 pb-0",
    attrs: {
      "cloumn": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [(!_vm.error || !_vm.signUpProcess) ? _c('v-btn', {
    staticClass: "blue accent-4 white--text",
    attrs: {
      "type": "submit",
      "disable": _vm.loading,
      "loading": _vm.loading
    }
  }, [_vm._v("\n                  Create Account\n                  "), _c('span', {
    staticClass: "custom-loader",
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("cached")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.error && _vm.signUpProcess) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('alert', {
    staticClass: "py-2",
    attrs: {
      "text": _vm.error,
      "error": true,
      "success": false
    },
    on: {
      "dismissed": _vm.onDismiss
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tabs-content', {
    attrs: {
      "id": "SIGN-IN"
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "column": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-card-title', {
    staticClass: "bold title pb-1",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("SIGN IN TO YOUR ACCOUNT")]), _vm._v(" "), _c('b', {
    staticClass: "caption pt-0 pb-2"
  }, [_vm._v("continue with")]), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-0",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-btn', {
    staticClass: "red accent-4 white--text mr-1",
    attrs: {
      "block": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.signInWithGoogle.apply(null, arguments)
      }
    }
  }, [_vm._v("Sign in with Google")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-btn', {
    staticClass: "green accent-4 white--text ml-1",
    attrs: {
      "block": ""
    }
  }, [_vm._v("Sign in with LinkedIn")])], 1)], 1), _vm._v(" "), _c('b', {
    staticClass: "caption mt-2 mb-0"
  }, [_vm._v("or")]), _vm._v(" "), _c('form', {
    staticClass: "py-0 my-0",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSignIn.apply(null, arguments)
      }
    }
  }, [_c('v-container', {
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pr-2",
    staticStyle: {
      "padding-bottom": "0px",
      "margin": "0px"
    },
    attrs: {
      "label": "Email Address",
      "type": "email",
      "required": ""
    },
    model: {
      value: (_vm.signIn.email),
      callback: function($$v) {
        _vm.$set(_vm.signIn, "email", $$v)
      },
      expression: "signIn.email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pr-2",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "label": "Password",
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.signIn.password),
      callback: function($$v) {
        _vm.$set(_vm.signIn, "password", $$v)
      },
      expression: "signIn.password"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "cloumn": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [(!_vm.error || !_vm.signInProcess) ? _c('v-btn', {
    staticClass: "blue accent-4 white--text",
    attrs: {
      "type": "submit",
      "disable": _vm.loading,
      "loading": _vm.loading
    }
  }, [_vm._v("\n                      Log In\n                      "), _c('span', {
    staticClass: "custom-loader",
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("cached")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.error && _vm.signInProcess) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('alert', {
    staticClass: "py-2",
    attrs: {
      "text": _vm.error,
      "error": true,
      "success": false
    },
    on: {
      "dismissed": _vm.onDismiss
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a0a7131a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/RegistrationComponent.vue
// module id = 1236
// module chunks = 19 27